import React, { useState } from "react";
import { canUseCare } from "../../helpers/careEnabled";
import { Card } from "reactstrap";
import { Link } from "react-router-dom";
// components Icons
import DashboardIcon from "../Components/Icons/DashboardIcon";
import OrganizationIcon from "../Components/Icons/OrganizationIcon";
import UserIcon from "../Components/Icons/UsersIcon";
import ArtformIcon from "../Components/Icons/ArtformIcon";
import SalesIcon from "../Components/Icons/SalesIcon";
import ProductionIcon from "../Components/Icons/ProductionIcon";
import IncomingIcon from "../Components/Icons/IncomingIcon";
import KarkhanaIcon from "../Components/Icons/KarkhanaIcon";
import CareIcon from "../Components/Icons/CareIcon";
import SettingsIcon from "../Components/Icons/SettingsIcon";
import CustomFieldsIcon from "../Components/Icons/CustomFieldsIcon";
import CategoryIcon from "../Components/Icons/CategoryIcon";
import SubCategoryIcon from "../Components/Icons/SubCategoryIcon";
import ProductIcon from "../Components/Icons/ProductIcon";
import WeaveTypeIcon from "../Components/Icons/WeaveTypeIcon";
import TypeIcon from "../Components/Icons/TypeIcon";
import CatalogueIcon from "../Components/Icons/CatalogueIcon";
// import Logo from "../../assets/images/D-3 1.jpg";
import CatalogIcon from "../../assets/images/icons8-catalog-50.png";
import { isStudioCatalogueNavPath } from "../../components/catalogue/cataloguePaths";
import GiRegistryIcon from "../Components/Icons/GiRegistryIcon";
import LoomsIcon from "../Components/Icons/LoomsIcon";
import PhysicalIdentityNavLink from "../../pages/physical-identity/PhysicalIdentityNavLink";
import CertificationsIcon from "../Components/Icons/CertificationsIcon";
import OrdersIcon from "../Components/Icons/OrdersIcon";
import { canUseGiRegistry } from "../../helpers/geoEnabled";
import { canUseOrders } from "../../helpers/orderEnabled";
import { canReceivePartnerOrders, canUseProductionNetwork } from "../../helpers/partnerNetworkEnabled";
import { canOpenKarkhana, isKarkhanaSupervisor } from "../../helpers/karkhanaEnabled";
import SupervisorMenu from "./SupervisorMenu";
import { canUseCatalogue } from "../../helpers/catalogueEnabled";
import { isTypeTagsEnabled } from "../../helpers/typeTagsEnabled";
/** Setup screens most studios rarely open; they sit under Settings so the menu stays short. */
const SETTINGS_PATHS = [
  "/artform",
  "/type",
  "/category",
  "/sub-category",
  "/weave-type",
  "/type-tags",
  "/process-master",
  "/custom-fields",
  "/care-templates",
];

const SideMiniExpand = (props: any) => {
  const { location, handleClick, authUser, closeSideBar } = props;
  const showSettings =
    authUser?.users?.role === "SUPER_ADMIN" ||
    (authUser?.users?.role === "ORGANIZATION_ADMIN" &&
      process.env.REACT_APP_PERMISSIONS_ORG_ADMIN === "true") ||
    (authUser?.users?.role === "ORGANIZATION_MANAGER" &&
      process.env.REAC_APP_PERMISSIONS_ORG_MANAGER === "true");
  const onSettingsPage = SETTINGS_PATHS.includes(location?.pathname);
  const [settingsOpen, setSettingsOpen] = useState(onSettingsPage);

  if (isKarkhanaSupervisor(authUser?.users?.role)) {
    return (
      <Card className="verticlemenuCard">
        <div className="parentList">
          <SupervisorMenu location={location} expanded={true} />
        </div>
      </Card>
    );
  }

  return (
    <Card className="verticlemenuCard">
      <div
        className="parentList"
        onClick={(event) => {
          if ((event.target as HTMLElement).closest("a")) {
            closeSideBar?.();
          }
        }}
      >
        <Link to="/dashboard" className="studio-sidebar-product" aria-label="HastKalaPramanak home">
          HastKalaPramanak
        </Link>
        <Link to="/dashboard">
          <div
            className={
              location?.pathname === "/dashboard"
                ? "verticleNameP verticleNamePOnclick"
                : "verticleNameP"
            }
            onClick={() =>
              handleClick({
                name: "dashboard",
              })
            }
          >
            <DashboardIcon />
            <span className="verticleName">Dashboard</span>
          </div>
        </Link>
        <Link to="/products">
          <div
            className={
              location?.pathname === "/products" ||
              location?.pathname === "/createProduct" ||
              location.pathname.split("/")[1] === "view-product" ||
              location.pathname.split("/")[1] === "pre-viewProduct" ||
              location.pathname.split("/")[1] === "edit-product"
                ? "verticleNameP verticleNamePOnclick"
                : "verticleNameP"
            }
            onClick={() => {
              handleClick({
                name: "products",
              });
            }}
          >
            <ProductIcon />
            <span className="verticleName">Products</span>
          </div>
        </Link>
        {canUseOrders(authUser?.users?.role) ? (
          <Link to="/orders">
            <div
              className={
                location?.pathname?.startsWith("/orders")
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() =>
                handleClick({
                  name: "orders",
                })
              }
            >
              <OrdersIcon />
              <span className="verticleName">Orders</span>
            </div>
          </Link>
        ) : (
          ""
        )}
        {canUseOrders(authUser?.users?.role) ? (
          <Link to="/sales">
            <div
              className={
                location?.pathname?.startsWith("/sales")
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() =>
                handleClick({
                  name: "sales",
                })
              }
            >
              <SalesIcon />
              <span className="verticleName">Sales</span>
            </div>
          </Link>
        ) : (
          ""
        )}
        {canUseProductionNetwork(authUser?.users?.role) ? (
          <Link to="/partner-network/board">
            <div
              className={
                location?.pathname?.startsWith("/partner-network/") && !location?.pathname?.startsWith("/partner-network/incoming")
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() =>
                handleClick({
                  name: "production",
                })
              }
            >
              <ProductionIcon />
              <span className="verticleName">Production</span>
            </div>
          </Link>
        ) : (
          ""
        )}
        {canReceivePartnerOrders(authUser?.users?.role) ? (
          <Link to="/partner-network/incoming">
            <div
              className={
                location?.pathname?.startsWith("/partner-network/incoming")
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() =>
                handleClick({
                  name: "incoming",
                })
              }
            >
              <IncomingIcon />
              <span className="verticleName">Incoming</span>
            </div>
          </Link>
        ) : (
          ""
        )}
        {canOpenKarkhana(authUser?.users?.role) ? (
          <Link to="/karkhana">
            <div
              className={
                location?.pathname === "/karkhana" || location?.pathname?.startsWith("/karkhana/")
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() =>
                handleClick({
                  name: "karkhana",
                })
              }
            >
              <KarkhanaIcon />
              <span className="verticleName">Karkhana</span>
            </div>
          </Link>
        ) : (
          ""
        )}
        <Link to="/collector-access-requests">
          <div
            className={
              location?.pathname === "/collector-access-requests"
                ? "verticleNameP verticleNamePOnclick"
                : "verticleNameP"
            }
            onClick={() =>
              handleClick({
                name: "collector-access-requests",
              })
            }
          >
            <ProductIcon />
            <span className="verticleName">Collector requests</span>
          </div>
        </Link>
        {authUser?.users?.role === "SUPER_ADMIN" ? (
          // ||
          // (authUser?.users?.role === "ORGANIZATION_ADMIN" &&
          //   process.env.REACT_APP_PERMISSIONS_ORG_ADMIN === "true") ||
          // (authUser?.users?.role === "ORGANIZATION_MANAGER" &&
          //   process.env.REAC_APP_PERMISSIONS_ORG_MANAGER === "true")
          <>
            <Link to="/organisation">
              <div
                className={
                  location?.pathname === "/organisation"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "organisation",
                  })
                }
              >
                <OrganizationIcon />
                <span className="verticleName">Organizations</span>
              </div>
            </Link>
            <Link to="/nfc-tags">
              <div
                className={
                  location?.pathname === "/nfc-tags"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "nfc-tags",
                  })
                }
              >
                <ProductIcon />
                <span className="verticleName">HKP tags</span>
              </div>
            </Link>
          </>
        ) : (
          ""
        )}
        {canUseCatalogue(authUser?.users?.role) ? (
          //    &&
          // authUser?.users?.organizationResponse?.organizationType ===
          //   "Manufacturer"
          <Link to="/catalogue">
            <div
              className={
                isStudioCatalogueNavPath(location?.pathname)
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() =>
                handleClick({
                  name: "catalogue",
                })
              }
            >
              <CatalogueIcon />
              <span className="verticleName">Catalogue</span>
            </div>
          </Link>
        ) : (
          ""
        )}

        {/* {(authUser?.users?.role === "ORGANIZATION_ADMIN" ||
          authUser?.users?.role === "ORGANIZATION_MANAGER") &&
        authUser?.users?.organizationResponse?.organizationType ===
          "Design Agency" ? (
          <Link to="/manufactures">
            <div
              className={
                location?.pathname === "/manufactures"
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
            >
              <OrganizationIcon />
              <span className="verticleName">Manufacturers</span>
            </div>
          </Link>
        ) : (
          ""
        )} */}
        {authUser?.users?.role === "ORGANIZATION_ADMIN" ||
        authUser?.users?.role === "ORGANIZATION_MANAGER" ? (
          //    &&
          // authUser?.users?.organizationResponse?.organizationType ===
          //   "Manufacturer"
          <Link to="/party">
            <div
              className={
                location?.pathname === "/party"
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
            >
              <OrganizationIcon />
              <span className="verticleName">Party</span>
            </div>
          </Link>
        ) : (
          ""
        )}

        {/* <Link to="/Manufacturers">
          <div
            className={
              location?.pathname === "/Manufacturers"
                ? "verticleNameP verticleNamePOnclick"
                : "verticleNameP"
            }
          >
            <OrganizationIcon />
            <span className="verticleName">Manufacturers</span>
          </div>
        </Link> */}
        <Link to="/users">
          <div
            className={
              location?.pathname === "/users" ||
              location?.pathname === "/createUser" ||
              location.pathname.split("/")[1] === "editUser" ||
              location.pathname.split("/")[1] === "viewUser"
                ? "verticleNameP verticleNamePOnclick"
                : "verticleNameP"
            }
            onClick={() =>
              handleClick({
                name: "users",
              })
            }
          >
            <UserIcon />
            <span className="verticleName">Users</span>
          </div>
        </Link>
        <PhysicalIdentityNavLink role={authUser?.users?.role} />
        {canUseGiRegistry(authUser?.users?.role) ? (
          <Link to="/gi-registry">
            <div
              className={
                location?.pathname?.startsWith("/gi-registry")
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() =>
                handleClick({
                  name: "gi-registry",
                })
              }
            >
              <GiRegistryIcon />
              <span className="verticleName">GI Registry</span>
            </div>
          </Link>
        ) : (
          ""
        )}
        {canUseGiRegistry(authUser?.users?.role) ? (
          <Link to="/looms">
            <div
              className={
                location?.pathname?.startsWith("/looms")
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() =>
                handleClick({
                  name: "looms",
                })
              }
            >
              <LoomsIcon />
              <span className="verticleName">Looms</span>
            </div>
          </Link>
        ) : (
          ""
        )}
        {canUseGiRegistry(authUser?.users?.role) ? (
          <Link to="/certifications">
            <div
              className={
                location?.pathname?.startsWith("/certifications")
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() =>
                handleClick({
                  name: "certifications",
                })
              }
            >
              <CertificationsIcon />
              <span className="verticleName">Certifications</span>
            </div>
          </Link>
        ) : (
          ""
        )}
        {showSettings ? (
          <>
            <button
              type="button"
              className={
                onSettingsPage
                  ? "verticleNameP studio-settings-toggle verticleNamePOnclick"
                  : "verticleNameP studio-settings-toggle"
              }
              aria-expanded={settingsOpen}
              aria-controls="studio-settings-links"
              onClick={() => setSettingsOpen((open) => !open)}
            >
              <SettingsIcon />
              <span className="verticleName">Settings</span>
              <span className="studio-settings-toggle__chevron" aria-hidden="true">
                {settingsOpen ? "\u25B4" : "\u25BE"}
              </span>
            </button>
            {settingsOpen && (
            <div id="studio-settings-links" className="studio-settings-links">
            <Link to="/artform">
              <div
                className={
                  location?.pathname === "/artform"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "artform",
                  })
                }
              >
                <ArtformIcon />
                <span className="verticleName">Artforms</span>
              </div>
            </Link>
            <Link to="/type">
              <div
                className={
                  location?.pathname === "/type"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "type",
                  })
                }
              >
                <TypeIcon />
                <span className="verticleName">Types</span>
              </div>
            </Link>
            <Link to="/category">
              <div
                className={
                  location?.pathname === "/category"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "category",
                  })
                }
              >
                <CategoryIcon />
                <span className="verticleName">Category</span>
              </div>
            </Link>
            <Link to="/sub-category">
              <div
                className={
                  location?.pathname === "/sub-category"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "sub-category",
                  })
                }
              >
                <SubCategoryIcon />
                <span className="verticleName">Sub-Category</span>
              </div>
            </Link>
            <Link to="/weave-type">
              <div
                className={
                  location?.pathname === "/weave-type"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "weave-type",
                  })
                }
              >
                <WeaveTypeIcon />
                <span className="verticleName">Weave Types</span>
              </div>
            </Link>
            {isTypeTagsEnabled() ? (
              <Link to="/type-tags">
                <div
                  className={
                    location?.pathname === "/type-tags"
                      ? "verticleNameP verticleNamePOnclick"
                      : "verticleNameP"
                  }
                  onClick={() =>
                    handleClick({
                      name: "type-tags",
                    })
                  }
                >
                  <WeaveTypeIcon />
                  <span className="verticleName">Type tags</span>
                </div>
              </Link>
            ) : null}
            <Link to="/process-master">
              <div
                className={
                  location?.pathname === "/process-master"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "process-master",
                  })
                }
              >
                <TypeIcon />
                <span className="verticleName">Process Master</span>
              </div>
            </Link>
            <Link to="/custom-fields">
              <div
                className={
                  location?.pathname === "/custom-fields"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "custom-fields",
                  })
                }
              >
                <CustomFieldsIcon />
                <span className="verticleName">Custom Fields</span>
              </div>
            </Link>
            {canUseCare(authUser?.users?.role) && (
              <Link to="/care-templates">
                <div
                  className={
                    location?.pathname?.startsWith("/care-templates")
                      ? "verticleNameP verticleNamePOnclick"
                      : "verticleNameP"
                  }
                  onClick={() =>
                    handleClick({
                      name: "care-templates",
                    })
                  }
                >
                  <CareIcon />
                  <span className="verticleName">Care Templates</span>
                </div>
              </Link>
            )}
            </div>
            )}
          </>
        ) : (
          ""
        )}
        {!showSettings && canUseCare(authUser?.users?.role) && (
          <Link to="/care-templates">
            <div
              className={
                location?.pathname?.startsWith("/care-templates")
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() => handleClick({ name: "care-templates" })}
            >
              <CareIcon />
              <span className="verticleName">Care Templates</span>
            </div>
          </Link>
        )}
      </div>
    </Card>
  );
};

export default SideMiniExpand;
